import { MenuOutlined } from '@ant-design/icons';
import { SortableHandle, SortableContainer, SortableElement } from 'react-sortable-hoc';

export const DragHandle = SortableHandle(() => <MenuOutlined style={{ cursor: 'grab', color: '#999', }} />);

export const SortableItem = SortableElement((props) => <tr {...props} />);

export const SortableBody = SortableContainer((props) => <tbody {...props} />);

//拖动前设置每个td的宽度, 防止表格错乱
export function updateBeforeSortStart({ node } = {}) {
  const tds = node.childNodes;
  for (var i = 0; i < tds.length; i++) {
    tds[i].style.width = `${tds[i].offsetWidth}px`;
  }
};
